/* TomorrowMade — global theme behavior
   Page-specific behavior (WebGL hero, marquee, collection switcher, drag rails)
   lives inside the relevant sections. This file is shared chrome only. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover:none),(pointer:coarse)').matches;
  window.TM = window.TM || {};
  window.TM.reduce = reduce;
  window.TM.touch = touch;

  /* ---------- CURSOR ---------- */
  (function () {
    if (touch) return;
    var cur = document.querySelector('.cursor');
    if (!cur) return;
    var x = innerWidth / 2, y = innerHeight / 2, tx = x, ty = y;
    addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; cur.style.opacity = 1; });
    (function loop() {
      x += (tx - x) * 0.2; y += (ty - y) * 0.2;
      cur.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      requestAnimationFrame(loop);
    })();
    var hot = function () { cur.classList.add('hot'); };
    var cool = function () { cur.classList.remove('hot'); };
    var bind = function () {
      document.querySelectorAll('a,button,[data-hot],input').forEach(function (el) {
        if (el.dataset.tmCursor) return;
        el.dataset.tmCursor = '1';
        el.addEventListener('mouseenter', hot);
        el.addEventListener('mouseleave', cool);
      });
    };
    bind();
    window.TM.bindCursor = bind; // sections can re-bind after injecting nodes
  })();

  /* ---------- NAV ---------- */
  (function () {
    var nav = document.getElementById('nav');
    if (nav) {
      addEventListener('scroll', function () { nav.classList.toggle('solid', scrollY > 40); });
    }
    var burger = document.getElementById('burger');
    if (burger) {
      burger.addEventListener('click', function () {
        document.body.classList.toggle('nav-open');
        burger.classList.toggle('on');
      });
    }
    // close mobile menu on link tap
    document.querySelectorAll('.nav__mobile a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('nav-open');
        if (burger) burger.classList.remove('on');
      });
    });
  })();

  /* ---------- GSAP: site-wide reveals + parallax ---------- */
  window.addEventListener('load', function () {
    if (typeof gsap === 'undefined') {
      // No GSAP — make sure nothing stays hidden.
      document.querySelectorAll('.reveal').forEach(function (el) { el.style.opacity = 1; el.style.transform = 'none'; });
      return;
    }
    if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

    // clip lines (used by manifesto-style headings)
    if (typeof ScrollTrigger !== 'undefined') {
      gsap.utils.toArray('.clipline').forEach(function (el) {
        gsap.to(el, {
          y: '0%', duration: 1.1, ease: 'expo.out',
          scrollTrigger: { trigger: el.closest('.clipwrap, section, .section') || el, start: 'top 80%' }
        });
      });

      // generic reveals
      gsap.utils.toArray('.reveal').forEach(function (el) {
        gsap.to(el, {
          opacity: 1, y: 0, duration: 1, ease: 'expo.out',
          scrollTrigger: { trigger: el, start: 'top 88%' }
        });
      });

      // parallax media
      gsap.utils.toArray('[data-parallax] img, [data-parallax] .chrome').forEach(function (el) {
        gsap.fromTo(el, { yPercent: -6 }, {
          yPercent: 6, ease: 'none',
          scrollTrigger: { trigger: el.closest('[data-parallax]'), start: 'top bottom', end: 'bottom top', scrub: true }
        });
      });

      ScrollTrigger.refresh();
    } else {
      document.querySelectorAll('.reveal').forEach(function (el) { el.style.opacity = 1; el.style.transform = 'none'; });
    }
  });
})();
